<template>
  <div class="register-page">
    <div class="go-to" v-if="!isFromMyProfile && (!isEidt || `${userInfo.memberType}` === '0')" @click="handleRegist">
      强生员工通道
      <img src="@/assets/images/aifv/img13.png" class="icon-arrow" alt=""/>
    </div>
    <div class="register-div">
      <div class="div-label">
        <span class="label-col">*</span>
        昵称
      </div>
      <div class="div-input">
        <input
          type="text"
          class="input-txt"
          placeholder="请输入昵称，仅支持中英文输入"
          v-model="user.nickName"
          maxlength="100"
        />
      </div>
    </div>
    <div class="title-line">
      <h4>实名认证</h4>
      <div class="line"></div>
    </div>
    <div class="register-div" :class="isDisabledSix ?'disabled':''">
      <div class="div-label">
        <span class="label-col">*</span>
        姓名
      </div>
      <div class="div-input">
        <input
          type="text"
          class="input-txt"
          placeholder="请输入姓名，仅支持中文输入"
          v-model="user.realName"
          maxlength="100"
          :readonly="isDisabledSix"
        />
      </div>
    </div>
    <div class="register-div" :class="isDisabledSix ?'disabled':''">
      <div class="div-label">
        <span class="label-col">*</span>
        性别
      </div>
      <div class="div-input">
        <template v-if="isDisabledSix">
          <span v-if="user.gender === '1'" class="div-input-sex-text">男</span>
          <span v-if="user.gender === '2'" class="div-input-sex-text">女</span>
        </template>
        <div v-else class="div-input-sex">
          <div
            class="sex-btn"
            :class="user.gender === '1' ? 'cur' : ''"
            @click="user.gender = '1'"
          >
            <img
              src="../../assets/images/regist/img2.png"
              class="icon-sex"
              alt=""
            />
            <span class="txt">男</span>
          </div>
          <div
            class="sex-btn"
            :class="user.gender === '2' ? 'cur' : ''"
            @click="user.gender = '2'"
          >
            <img
              src="../../assets/images/regist/img6.png"
              class="icon-sex"
              alt=""
            />
            <span class="txt">女</span>
          </div>
        </div>
      </div>
    </div>
    <div class="register-div" :class="isDisabledSix ?'disabled':''">
      <div class="div-label">
        <span class="label-col">*</span>
        手机号
      </div>
      <div class="div-input" v-if="!isEidt || (isEidt && user.phone !== defaultPhone)">
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]{0,11}"
          :maxlength="11"
          class="input-txt"
          placeholder="请输入手机号"
          v-model="user.phone"
          :readonly="isMyProfileLocked"
        />
        <div class="send-btn" @click="handleSendCode">{{
            counting ? `${count}秒后重新获取` : "发送验证码"
          }}
        </div>
      </div>
      <div class="div-input" v-else-if="isEidt && user.phone === defaultPhone">
        <input
          type="number"
          :maxlength="11"
          class="input-txt"
          placeholder="请输入手机号"
          v-model="user.phone"
          :readonly="isDisabledSix"
        />
      </div>
    </div>
    <div class="register-div" v-if="user.phone !== defaultPhone">
      <div class="div-label">
        <span class="label-col">*</span>
        验证码
      </div>
      <div class="div-input">
        <input
          type="text"
          class="input-txt"
          placeholder="请输入验证码"
          v-model="user.phoneCode"
        />
      </div>
    </div>
    <div class="register-div" :class="isDisabledSix ?'disabled':''">
      <div class="div-label">
        <span class="label-col">*</span>
        医院
      </div>
      <div class="div-input" @click="handleClickHos('click')">
        <input
          type="text"
          class="input-txt"
          placeholder="请选择医院"
          v-model="user.hospitalName"
          readonly
        />
        <img src="@/assets/images/regist/img4.png" class="icon-arrow" alt=""/>
      </div>
    </div>
    <div class="tip-div">
      <van-icon name="info-o" color="#A39992"
                @click="showTip('当iEP平台举办线上培训活动时，为保证所在活动的真实性和管理规范性，系统将会显示您的真实医院信息和真实姓名。')"/>
      <span>医院对外显示</span>
      <van-switch v-model="user.isPublicHospital" size="15" :active-value="1" :inactive-value="0"
                  active-color="#EB1700"/>
    </div>
    <div class="register-div" :class="isDisabledSix ?'disabled':''">
      <div class="div-label">
        <span class="label-col">*</span>
        职称
      </div>
      <div class="div-input" @click="handleClickPosition">
        <input
          type="text"
          class="input-txt"
          placeholder="请选择职称"
          v-model="user.positionTitle"
          readonly
        />
        <img src="@/assets/images/regist/img4.png" class="icon-arrow" alt=""/>
      </div>
    </div>
    <div class="register-div" :class="isDisabledSix ?'disabled':''">
      <div class="div-label">
        <span class="label-col">*</span>
        科室
      </div>
      <div class="div-input" @click="handleClickDepartment">
        <input
          type="text"
          class="input-txt"
          placeholder="请选择科室"
          v-model="user.major"
          readonly
        />
        <img src="@/assets/images/regist/img4.png" class="icon-arrow" alt=""/>
      </div>
    </div>
    <div class="register-div">
      <div class="div-label">
        <!-- <span class="label-col">*</span> -->
        主要负责手术
      </div>
      <div class="div-input" @click="handleClickOperation">
        <input
          type="text"
          class="input-txt"
          placeholder="请选择主要负责手术"
          v-model="user.operation"
          readonly
        />
        <img src="@/assets/images/regist/img4.png" class="icon-arrow" alt=""/>
      </div>
    </div>
    <div class="tip-txt" v-if="showTxt">为了更好的使用iEP，请您补全注册信息</div>
    <div class="submit-div" v-if="isEidt">
      <div class="submit-btn" @click="handleSubmit">提交修改</div>
      <div class="submit-btn-line" v-if="!backUrl" @click="handleCancel">取消修改</div>
    </div>
    <div class="submit-div" v-else>
      <div class="submit-btn" @click="handleSubmit">注册</div>
    </div>
    <div class="submit-div tip">
      用户您好，为了确保您能够顺利使用本平台的各项服务，请确保注册信息真实准确。若认证无法通过，则无法继续使用平台功能。我们承诺在您注册提交后的10个工作日内给予反馈，期间请保持电话畅通，用于身份认证，请耐心等待，感谢您的支持与理解！
    </div>
    <div
      class="dailog-div"
      v-if="isOperation || ismajor || isHos || isPosition"
    >
      <div class="dialog-bg"></div>
      <div class="dialog-cons" :class="{ search: true }">
        <template v-if="isOperation">
          <div class="cons-title">
            <span class="cancel-btn" @click="handleClose">取消</span>
            <span class="title-txt">主要手术类型(可多选)</span>
            <span class="confirm-btn" @click="handleConfirmOperation"
            >确定</span
            >
          </div>
          <div class="cons-content">
            <div
              class="cons-item"
              @click="handleOperationItem(item)"
              :class="operationItemArr.includes(item.value) ? 'cur' : ''"
              v-for="(item, index) in operationArr"
              :key="index"
            >
              {{ item.value }}
            </div>
          </div>
        </template>
        <template v-if="ismajor || isPosition">
          <div class="cons-title">
            <span class="cancel-btn" @click="handleClose">取消</span>
            <span class="title-txt">{{
                ismajor ? "请选择科室" : "请选择职称"
              }}</span>
            <span class="confirm-btn" @click="handleConfirmDepartment"
            >确定</span
            >
          </div>
          <van-picker
            class="picker"
            :item-height="60"
            :columns="columns"
            @change="onChange"
            :loading="columns.length <= 0"
          />
        </template>
        <template v-if="isHos">
          <div class="cons-title">
            <span class="cancel-btn" @click="handleClose">取消</span>
            <span class="title-txt">请选择医院</span>
            <span class="confirm-btn"></span>
          </div>
          <div class="cons-search-hos">
            <div class="search-hos-div">
              <input
                type="search"
                class="input-search"
                placeholder="请输入医院名称"
                v-model="hospitalSearch"
                @keydown.enter.prevent="handleClickHos('search')"
              />
              <div class="border-btn" @click.stop="handleClickHos('search')">
                <img src="../../assets/images/home/img4.png" class="icon-search" alt="">
                <span class="btn-txt">搜索</span>
              </div>
            </div>
            <div class="search-hos-list">
              <div
                class="search-hos-item"
                v-for="(item, index) in hospitalList"
                :key="index"
                @click="handleClickHosItem(item)"
              >
                <div class="item-name">{{ item.cnName }}</div>
                <div class="item-addr">{{ item.address }}</div>
              </div>
              <div class="search-more" v-if="!isLoad" @click="handleClickMoreHos">
                加载更多...
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getHospitalList,
  dataDictionary,
  register,
  sendPhoneMessage,
  getIepUserInfo,
  getCiamUserInfoByOpenId,
  updateUserById,
  updateZiliaoUserById,
} from '@/api/register'

import {beforeLoginFun, redirectToWxAuth} from '@/utils/util'

import withRouteTracking from '@/utils/withRouteTracking'
import {getLoginFrontId, getUserIdentity, veevaStatusFail, veevaStatusSuccess} from '../../utils/util'
import {queryPermissionsByUser, systemRedisGet} from '../../api/api'
import {USER_INFO} from '../../store/mutation-types'
import qs from 'qs'

const UserProfile = {
  name: 'Register',
  data() {
    return {
      // 用户提交表单
      user: {
        major: '',
        gender: null, // 性别  (1, "男"), (2, "女")
        phone: '', // 手机号
        positionTitle: '', // 职称
        operation: '',
        phoneCode: '', // 验证码
        nickName: '', // 真实姓名
        realName: '', // 真实姓名
        hospitalName: '', // 医院
        isPublicHospital: 1, // 是否显示医院
        hospitalId: '', // 医院id
        iepOpenId: '', // openid
      },
      hospitalSearch: '',
      columns: [],
      departArr: [],
      postionsArr: [],
      operationArr: [],
      hospitalList: [],
      isLoad: false,
      departIndex: 0,
      isOperation: false,
      ismajor: false,
      isPosition: false,
      isHos: false,
      pageNum: 1,
      count: 60,
      counting: false,
      timer: null,
      endTime: null,
      defaultPhone: '',
      operationItemArr: [],
      showTxt: false,
      confirmLoading: false,
      userIdentity: getUserIdentity()
    }
  },
  computed: {
    isEidt() {
      return this.$route.query.isEidt
    },
    backUrl() {
      return JSON.parse(sessionStorage.getItem('iepLoginResult')).backurl
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    // 从「我的-资料修改」进入
    isFromMyProfile() {
      return this.$route.query.userAuth === 'my'
    },
    // 我的-资料修改且认证中：全字段锁定
    isMyProfileLocked() {
      return this.isFromMyProfile && this.isDisabledSix
    },
    isDisabledSix() {
      if (this.isFromMyProfile) {
        if (!this.isEidt) {
          return false
        }
        const veevaStatus = this.userIdentity && this.userIdentity.veevaStatus
        if (!veevaStatus) {
          return false
        }
        const isSuccess = veevaStatusSuccess.includes(veevaStatus)
        const isFail = veevaStatusFail.includes(veevaStatus)
        // 认证中不可改；有效/无效均可改全部字段
        return !isSuccess && !isFail
      }
      // 其他入口保持原六字段锁定逻辑
      const isComplementType = this.$route.query.type === 'complement'
      if (isComplementType) {
        return false
      }
      const userIdentity = this.userIdentity
      if (userIdentity) {
        const isVeevaStatusFail = typeof veevaStatusFail !== 'undefined' &&
          veevaStatusFail.includes(userIdentity.veevaStatus)
        const isUpdateNumberValid = userIdentity.updateNumber < userIdentity.defaultUpdateNumber
        if (!userIdentity.veevaStatus && isUpdateNumberValid) {
          return false
        }
        if (isVeevaStatusFail && isUpdateNumberValid) {
          return false
        }
      }
      return this.isEidt
    }

  },
  mounted() {
    this.$nextTick(async () => {
      if (!this.isEidt) {
        if (this.$route.query.openId) {
          this.user.iepOpenId = this.$route.query.openId
        }
        if (!this.user.iepOpenId) {
          // 没有从地址栏获取到openid, 就调用接口获取, 如果还没有获取到, 就提示用户
          const frontId = getLoginFrontId()
          if (frontId) {
            const {data} = await systemRedisGet({
              key: `registerFrontId_${frontId}`
            })
            if (data) {
              this.user.iepOpenId = data.openId
            }
          }
        }
      } else {
        this.user.iepOpenId = this.userInfo.iepOpenId
      }
      if (!this.user.iepOpenId) {
        this.$toast('重新授权')
        setTimeout(() => {
          this.$router.push({
            path: '/home'
          })
        }, 500)
        return
      }
      if (this.$route.query.type === 'complement') {
        this.showTxt = true
      }
      this.ryParameter('openId')
      this.restoreCountdown()
      if (this.isEidt && this.user.iepOpenId) {
        const res = await getIepUserInfo({iepOpenId: this.user.iepOpenId})
        if (res.code === 0) {
          this.defaultPhone = res.data.phone
          this.user.major = res.data.major
          this.user.gender = res.data.gender === '男' ? '1' : res.data.gender === '女' ? '2' : '' // 性别  (1 "男") (2 "女")
          this.user.phone = res.data.phone // 手机号
          this.user.positionTitle = res.data.positionTitle // 职称
          this.user.operation = res.data.operation
          this.user.realName = res.data.realName // 真实姓名
          this.user.nickName = res.data.nickName // 真实姓名
          this.user.hospitalName = res.data.hospitalName // 医院
          this.user.isPublicHospital = res.data.isPublicHospital // 医院
          this.hospitalSearch = res.data.hospitalName // 医院
          this.user.hospitalId = res.data.hospitalId // 医院id
          this.user.userId = res.data.id
          this.operationItemArr = res.data.operation ? res.data.operation.split('|') : []
        }
      } else {
        if (this.user.iepOpenId) {
          const res = await getCiamUserInfoByOpenId(this.user.iepOpenId)
          if (res.code === 0) {
            const ciamGender = res.data.gender
            if (ciamGender === 1 || ciamGender === '1' || ciamGender === 'M') {
              this.user.gender = '1'
            } else if (ciamGender === 0 || ciamGender === '0' || ciamGender === 'F') {
              this.user.gender = '2'
            } else {
              this.user.gender = ''
            }
            this.user.hospitalName = res.data.hospitalName // 医院
            this.user.isPublicHospital = 1 // 医院
            this.hospitalSearch = res.data.hospitalName // 医院
            this.user.hospitalId = res.data.hospitalId // 医院id
            this.user.major = res.data.major
            this.user.phone = res.data.phone // 手机号
            this.user.positionTitle = res.data.positionTitle // 职称
            this.user.realName = res.data.realName // 真实姓名
            this.user.nickName = res.data.nickName // 真实姓名
          }
        }
      }
    })
  },
  beforeDestroy() {
    this.resetCountdown()
  },
  methods: {
    showTip(txt) {
      this.$toast({
        message: txt,
        duration: 2000,
      })
    },
    ryParameter(paramName) {
      // 获取当前的查询参数
      const query = {...this.$route.query}
      if (!query.openId) return
      // 删除指定的参数
      delete query[paramName]

      // 使用 this.$router.replace 替换当前路由，不添加历史记录
      this.$router.replace({
        path: this.$route.path, // 保持相同的路径
        query: query // 更新后的查询参数
      })
    },
    handleRegist() {
      if (window.location.href.indexOf('iep.jjmc.cn') > -1) {
        window.location.href = `https://login.microsoftonline.com/3ac94b33-9135-4821-9502-eafda6592a35/oauth2/v2.0/authorize?client_id=c1a2376f-8a45-4367-8c08-43e6afeb037b&response_type=code&redirect_uri=https://iep.jjmc.cn/openapi/sso/login/mobile/callback&response_mode=query&scope=address%20email%20openid%20phone%20profile`
      } else {
        window.location.href = `https://login.microsoftonline.com/3ac94b33-9135-4821-9502-eafda6592a35/oauth2/v2.0/authorize?client_id=9d5755bd-c975-4198-828e-cb7933e31319&response_type=code&redirect_uri=https://cartojourneyqa.jjmc.cn/openapi/sso/login/mobile/callback&response_mode=query&scope=address%20email%20openid%20phone%20profile`
      }
    },
    startCountdown() {
      if (this.counting) return
      this.counting = true
      this.endTime = Date.now() + this.count * 1000
      localStorage.setItem('endTime', this.endTime)

      this.timer = setInterval(() => {
        this.updateCountdown()
      }, 1000)
    },
    updateCountdown() {
      const now = Date.now()
      if (now >= this.endTime) {
        this.resetCountdown()
      } else {
        this.count = Math.ceil((this.endTime - now) / 1000)
      }
    },
    resetCountdown() {
      clearInterval(this.timer)
      this.count = 60
      this.counting = false
      this.endTime = null
      localStorage.removeItem('endTime')
    },
    restoreCountdown() {
      const savedEndTime = localStorage.getItem('endTime')
      if (savedEndTime) {
        this.endTime = parseInt(savedEndTime, 10)
        this.counting = true
        this.updateCountdown()
        this.timer = setInterval(() => {
          this.updateCountdown()
        }, 1000)
      }
    },
    handleSendCode() {
      if (this.isMyProfileLocked) return
      if (!this.user.phone) {
        this.$toast('请填写手机号')
        return
      }
      sendPhoneMessage({phone: this.user.phone})
        .then((res) => {
          this.startCountdown()
        })
        .catch((err) => {
          this.$toast(err.msg)
          console.error(err)
        })
    },
    handleClose() {
      this.isOperation = false
      this.ismajor = false
      this.isHos = false
      this.isPosition = false
    },
    handleClickOperation() {
      if (this.operationArr.length <= 0) {
        let params = {
          typeCode: 'OPERATION',
          dataStatus: '1',
        }
        dataDictionary(params)
          .then((res) => {
            if (res.data.length <= 0) {
              this.$toast('暂无数据, 请联系管理员！')
              return
            }
            this.dataDictionaryOperation = res.data
            this.operationArr = res.data
          })
          .catch((err) => {
            console.error(err)
          })
      }
      this.isOperation = true
    },
    handleOperationItem(item) {
      if (this.operationItemArr.includes(item.value)) {
        this.operationItemArr = this.operationItemArr.filter(
          (item1) => item1 !== item.value
        )
      } else {
        this.operationItemArr.push(item.value)
      }
    },
    handleConfirmOperation() {
      this.user.operation = this.operationItemArr.join('|')
      this.isOperation = false
    },
    handleClickDepartment() {
      if (this.isDisabledSix) return
      this.departIndex = 0
      if (this.departArr.length <= 0) {
        let params = {
          typeCode: 'DEPARTMENT',
          dataStatus: '1',
        }
        dataDictionary(params)
          .then((res) => {
            if (res.data.length <= 0) {
              this.$toast('暂无数据, 请联系管理员！')
              return
            }
            this.dataDictionaryDepartment = res.data
            this.departArr = res.data.map((item) => item.value)
            this.columns = this.departArr
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        this.columns = this.departArr
      }
      this.ismajor = true
    },
    handleClickPosition() {
      if (this.isDisabledSix) return
      this.departIndex = 0
      if (this.postionsArr.length <= 0) {
        let params = {
          typeCode: 'POSITION_TITLE',
          dataStatus: '1',
        }
        dataDictionary(params)
          .then((res) => {
            if (res.data.length <= 0) {
              this.$toast('暂无数据, 请联系管理员！')
              return
            }
            this.dataDictionaryPosition = res.data
            this.postionsArr = res.data.map((item) => item.value)
            this.columns = this.postionsArr
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        this.columns = this.postionsArr
      }
      this.isPosition = true
    },
    onChange(picker, value, index) {
      this.departIndex = index
      console.log(`当前值：${value}, 当前索引：${index}`)
    },
    handleConfirmDepartment() {
      if (this.ismajor) {
        this.user.major =
          this.dataDictionaryDepartment[this.departIndex].value
        this.ismajor = false
      } else if (this.isPosition) {
        this.user.positionTitle =
          this.dataDictionaryPosition[this.departIndex].value
        this.isPosition = false
      }
    },
    handleClickHos(type) {
      if (this.isDisabledSix) return
      if (type === 'click') {
        this.hospitalSearch = this.user.hospitalName
      }
      if (type === 'search' || type === 'click') {
        this.pageNum = 1
        this.isLoad = false
        this.hospitalList = []
      }
      let params = {
        name: this.hospitalSearch,
        pageNum: this.pageNum,
        hpCusttypeCd: 1,
        custTypeCdIn: 1,
      }
      getHospitalList(params)
        .then((res) => {
          if (res.data.total <= 0) {
            this.$toast('暂无数据, 请联系管理员！')
            return
          }
          if (res.data.list && res.data.list.length > 0) {
            this.hospitalList = this.hospitalList.concat(res.data.list)
          }
          if (`${this.hospitalList.length}` === `${res.data.total}`) {
            this.isLoad = true
          }
          console.log(this.isLoad, '232')
        })
        .catch((err) => {
          console.error(err)
        })
      this.isHos = true
    },
    handleClickHosItem(item) {
      this.user.hospitalName = item.cnName
      this.user.hospitalId = item.id
      this.isHos = false
    },
    handleClickMoreHos() {
      this.pageNum++
      this.handleClickHos()
    },
    decode(urlTxt) {
      try {
        // 使用atob函数解码Base64
        return atob(urlTxt)
      } catch (error) {
        console.error('解码失败:', error)
      }
    },
    async handleSubmit() {
      const validationRules = [
        {
          field: 'nickName',
          message: '请正确填写昵称, 仅限中英文, 最多100字',
          regex: /^[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaffa-zA-Z·]+$/,
          maxLength: 100
        },
        {
          field: 'realName',
          message: '请正确填写姓名，不支持数字和特殊字符，最少2个字',
          regex: /^[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaffa-zA-Z·]+$/,
          minLength: 2,
          maxLength: 100
        },
        {field: 'gender', message: '请选择性别'},
        {field: 'phone', message: '请填写手机号'},
        {field: 'hospitalName', message: '请选择医院'},
        {field: 'positionTitle', message: '请选择职称'},
        {field: 'major', message: '请选择科室'},
        // { field: 'operation', message: '请选择主要手术' },
        {field: 'iepOpenId', message: 'iepOpenId不能为空！'}
      ]
      for (const rule of validationRules) {
        if (rule.field === 'nickName') {
          if (this.user.nickName === '' || this.user.nickName.length > rule.maxLength || !rule.regex.test(this.user.nickName)) {
            this.$toast(rule.message)
            return
          }
        } else if (rule.field === 'realName') {
          if (this.$route.query.userAuth === 'my' && this.isDisabledSix) continue
          if (this.user.realName === '' || this.user.realName.length < rule.minLength || this.user.realName.length > rule.maxLength || !rule.regex.test(this.user.realName)) {
            this.$toast(rule.message)
            return
          }
        } else if (!this.user[rule.field]) {
          this.$toast(rule.message)
          return
        }
      }
      if (this.user.phoneCode === '' && this.defaultPhone !== this.user.phone) {
        this.$toast('请填写验证码')
        return
      }
      try {
        if (this.confirmLoading) return
        this.confirmLoading = true
        const redirectURL = localStorage.getItem('redirectURL')
        let entrance, channel, linkUrl, shareUserId
        if (redirectURL) {
          try {
            const url = redirectURL.split('?')[1]
            const searchParams = qs.parse(url)
            entrance = searchParams.entrance
            channel = searchParams.channel
            linkUrl = window.btoa(redirectURL)
            shareUserId = searchParams.userId
          } catch (error) {
            console.error('解析 redirectURL 时出错:', error)
          }
        } else {
          console.log('localStorage 中没有找到 redirectURL')
        }
        if (this.$route.query.shareUrl) {
          linkUrl = this.$route.query.shareUrl
        }
        if (this.isEidt) {
          this.isFromMyProfile
            ? await updateZiliaoUserById(this.user)
            : await updateUserById(this.user)
          if (this.isFromMyProfile) {
            this.userIdentity = Object.assign({}, this.userIdentity || {}, {veevaStatus: '待验证'})
          }
        } else {
          await register(Object.assign({}, this.user, {
            entrance,
            channel,
            linkUrl,
            shareUserId
          }))
        }
        this.$toast(this.isEidt ? '修改成功' : '注册成功')
        if (!this.isEidt || this.$route.query.from === 'loginVerification') {
          sessionStorage.removeItem('iepLoginResult')
          const casesharingUrl = this.getCasesharingJumpUrl()
          if (casesharingUrl) {
            window.location.href = casesharingUrl
            return
          }
          // 有业务目标页时带上，避免再授权把 redirectURL 覆盖成 /register
          const authTarget = this.getAuthRedirectTarget(redirectURL)
          redirectToWxAuth(authTarget || undefined)
          return
        }
        setTimeout(async () => {
          let iepLoginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
          iepLoginResult.isUserInfo = '1'
          iepLoginResult.phone = this.user.phone
          const userRes = await getIepUserInfo({iepOpenId: this.user.iepOpenId})
          if (userRes && userRes.data) {
            iepLoginResult.userIdentity = Object.assign({}, iepLoginResult.userIdentity || {}, userRes.data)
            iepLoginResult.phone = userRes.data.phone || this.user.phone
            this.userIdentity = iepLoginResult.userIdentity
          }
          sessionStorage.setItem('iepLoginResult', JSON.stringify(iepLoginResult))
          const response = await queryPermissionsByUser()
          const result = response.data
          this.$store.commit('SET_INFO', result.userInfo)
          this.$ls.set(USER_INFO, result.userInfo)
          // const { backurl } = iepLoginResult
          // if (backurl) {
          //   window.location.href = atob(backurl)
          //   return
          // }
          if (beforeLoginFun()) {
            const casesharingUrl = this.getCasesharingJumpUrl()
            if (casesharingUrl) {
              window.location.href = casesharingUrl
              return
            }
            const target = this.getAuthRedirectTarget(localStorage.getItem('redirectURL'))
            if (target) {
              const hrefTxt = target.indexOf('/journeymob') > -1 ? target.substring(11) : target
              localStorage.removeItem('redirectURL')
              this.$router.push({ path: hrefTxt })
            } else {
              this.$router.go(-1)
            }
          }
        }, 1500)
      } catch (e) {
        this.confirmLoading = false
        this.$toast(e.msg)
        throw e
      } finally {
      }
    },
    getAuthRedirectTarget(url) {
      if (!url) return ''
      if (url.indexOf('/register') > -1 || url.indexOf('/loginPage') > -1 || url.indexOf('longTimeLogin') > -1) {
        return ''
      }
      return url
    },
    getCasesharingJumpUrl() {
      const shareUrl = this.$route.query.shareUrl
      if (!shareUrl) return ''
      let raw = shareUrl
      try {
        if (raw.indexOf('http://') !== 0 && raw.indexOf('https://') !== 0) {
          raw = window.atob(raw)
        }
      } catch (e) {
        return ''
      }
      const bingliUrl = process.env.bingliUrl || ''
      if (bingliUrl && raw.indexOf(bingliUrl) === 0) {
        return raw
      }
      return ''
    },
    handleCancel() {
      if (this.$route.query.from === 'loginVerification') {
        this.$router.back()
      } else {
        this.$router.push({
          path: '/person'
        })
      }
    },
  },
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.register-page {
  min-height: 100vh;
  width: 100%;
  background: #F9F8F7 url("../../assets/images/regist/img1.png") no-repeat center center/ 100% 100%;
  padding: 116px 25px 30px;
  box-sizing: border-box;

  .title-line {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 48px 0 15px;

    .line {
      flex: 1;
      height: 1px;
      margin-left: 5px;
      background: #F1F0F0;
    }
  }

  .go-to {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-family: PingFang HK, PingFang HK;
    font-weight: 500;
    font-size: 14px;
    color: #EB1700;
    margin-bottom: 20px;

    .icon-arrow {
      width: 16px;
      margin-left: 6px;
    }
  }

  .tip-div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 20px;

    span {
      margin: 0 10px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #A39992;
    }
  }

  .register-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 28px;
    padding: 5px 0;
    margin-bottom: 20px;

    &.disabled {
      cursor: not-allowed;

      .div-label {

        .label-col {
        }
      }

      .div-input {
        .input-txt {
          color: #606060;
        }
      }

      .div-input-sex-text {
        color: #606060;
        font-size: 14px;
        width: 100%;
        text-align: right;
      }
    }

    .div-label {
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 14px;

      .label-col {
        font-weight: 500;
        color: #ff0000;
      }
    }

    .div-input {
      width: 70%;
      display: flex;
      align-items: center;

      .icon-arrow {
        width: 6px;
        display: block;
        margin-left: 5px;
        height: auto;
      }

      .input-txt {
        font-family: PingFang HK, PingFang HK;
        font-size: 14px;
        color: #000000;
        border: none;
        outline: none;
        background-color: transparent;
        height: 100%;
        text-align: right;
        flex: 1;
        min-width: 1px;
      }

      .send-btn {
        font-family: PingFang HK, PingFang HK;
        font-size: 14px;
        color: #EB1700;
        margin-left: 10px;
      }

      .div-input-sex {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;

        .sex-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 65px;
          height: 28px;
          border-radius: 4px;
          margin-left: 16px;
          background: #F9F8F7;
          opacity: .6;

          &.cur {
            border: 1px solid #000;
            opacity: 1;

            .txt {
            }
          }

          .icon-sex {
            width: 14px;
            display: block;
            margin-right: 5px;
          }

          .txt {
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-size: 14px;
            color: #000;
          }
        }
      }
    }
  }

  .tip-txt {
    font-size: 14px;
    color: coral;
    line-height: 24px;
  }

  .submit-div {
    margin-top: 30px;

    &.tip {
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: .6;
    }

    .submit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #EB1700;
      width: 100%;
      height: 42px;
      border-radius: 100px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
    }

    .submit-btn-line {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 42px;
      border-radius: 100px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      color: #aeaeae;
      margin-top: 10px;
    }
  }
}

.dailog-div {
  width: 100%;
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999;

  .dialog-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .dialog-cons {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 300px;
    // border-radius: 10px;
    border-radius: 10px 10px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    background: #fff;

    &.search {
      height: 420px;
    }

    .dialog-cons-bg {
      background-repeat: no-repeat;
      background-size: 100%;
      background-image: url("../../assets/images/regist/img7.png");
      width: 100%;
      height: 60px;
      position: absolute;
      top: 0;
      left: 0;
    }

    /deep/ .van-picker-column__item--selected {
      background: rgb(249, 248, 247);
    }

    .cons-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      padding: 0 20px;
      border-bottom: 1px solid #ebebeb;
      position: relative;
      background: #fff;
      border-radius: 10px 10px 0 0;

      .cancel-btn {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        cursor: pointer;
      }

      .title-txt {
        font-family: PingFang HK, PingFang HK;
        font-weight: 600;
        font-size: 14px;
        color: #000000;
      }

      .confirm-btn {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #EB1700;
        cursor: pointer;
        width: 40px;
        text-align: right;
      }
    }

    .cons-search-hos {
      padding: 0 15px;
      box-sizing: border-box;
      margin-top: 10px;
      height: 350px;

      .search-hos-div {
        display: flex;
        align-items: center;
        height: 32px;
        border-radius: 100px;
        border: 1px solid #e3e3e3;
        padding-left: 10px;
        padding-right: 3px;
        box-sizing: border-box;

        .icon-search {
          width: 14px;
          display: block;
          margin-right: 5px;
        }

        input[type="search"] {
          font-family: PingFang HK, PingFang HK;
          font-size: 14px;
          color: #000000;
          border: none;
          outline: none;
          background-color: transparent;
          flex: 1;
          height: 100%;
        }

        .border-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 26px;
          border-radius: 25px;
          background: rgba(213, 207, 201, 0.5);
          cursor: pointer;

          .icon-search {
            width: 13px;
            display: block;
            margin-right: 4px;
          }

          .btn-txt {
            color: #000000;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 13px;
          }
        }

      }

      .search-hos-list {
        overflow-y: auto;
        height: 310px;

        .search-hos-item {
          padding: 16px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #e9e9e9;

          .item-name {
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            margin-right: 10px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            line-height: 20px;
            margin-bottom: 4px;
          }

          .item-addr {
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.6);
          }
        }

        .search-more {
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          color: #6a7481;
        }
      }
    }

    .cons-content {
      display: flex;
      flex-wrap: wrap;
      padding: 0 15px;
      box-sizing: border-box;
      margin-top: 10px;
      // height: 270px;
      overflow-y: auto;

      .cons-item {
        height: 35px;
        margin-bottom: 8px;
        font-family: PingFang HK, PingFang HK;
        font-weight: 400;
        font-size: 13px;
        color: #6a7481;
        border-radius: 8px;
        cursor: pointer;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background: rgb(249, 248, 247);
        margin-right: 7px;

        &.cur {
          border: 1px solid rgb(0, 0, 0);
          border-radius: 4px;
          color: #000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/loginPage/register.vue